import * as React from "react";
import { $, merge } from "glamor";
import { theme } from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import { List } from "react-virtualized/dist/commonjs/List";
import { InfiniteLoader } from "react-virtualized/dist/commonjs/InfiniteLoader";
import { DATATEST } from "constants/integration";
import { AutoSizer } from "react-virtualized/dist/commonjs/AutoSizer";

export const ROW_HEIGHT = 75;

interface IProps {
    app: any;
    onSnackbarAdd: any;
    rowCount: number;
    onGetBoardPermissions: any;
    loadMoreRows: any;
    rowRenderer: any;
    isRowLoaded: any;
    permittedUsers: any;
    usersToDelete: any;
    brandUsersOnly?: boolean;
}

export class PermissionList extends React.PureComponent<IProps, any> {
    static rowHeight = ROW_HEIGHT;
    infiniteLoader;

    private styles = merge(
        {
            position: "relative",
        },
        $(" .listHeader", {
            borderBottom: `1px solid ${theme.palette.borderColor}`,
            display: "flex",
            padding: "20px 0 10px 0",
        }),
        $(" .listHeader .userColumn", {
            width: "80%",
            fontWeight: "bold",
            color: theme.palette.darkGrey,
            fontSize: "14px",
        }),
        $(" .roleColumn", {
            fontWeight: "bold",
            color: theme.palette.darkGrey,
            fontSize: "14px",
        }),
        $(" .list", {
            borderBottom: this.props.permittedUsers.size ? `1px solid ${theme.palette.borderColor}` : "none",
        }),
        $(" .noResults", {
            backgroundColor: theme.palette.lighterGrey,
            textAlign: "center",
            padding: "12px",
            borderRadius: "5px",
            marginTop: "16px",
        })
    );

    componentDidUpdate(prevProps, prevState) {
        if (
            !prevProps.permittedUsers.equals(this.props.permittedUsers) ||
            !prevProps.usersToDelete.equals(this.props.usersToDelete)
        ) {
            this.infiniteLoader._registeredChild.Grid.forceUpdate();
        }
    }

    bindInfiniteLoader = (ref) => {
        this.infiniteLoader = ref;
    };

    getListHeight = () => {
        const { app, permittedUsers } = this.props;

        let height = permittedUsers.size * ROW_HEIGHT;

        if (permittedUsers.size > 4) {
            height = ROW_HEIGHT * 4.5;
        }

        if (app.height < 600) {
            height = ROW_HEIGHT * 2;
        }

        return height;
    };

    render() {
        const { app, rowCount, permittedUsers, brandUsersOnly } = this.props;

        return (
            <div
                {...this.styles}
                data-test={DATATEST.ASSORTMENTS.SHARE_RECIPIENTS_CONTAINER}
                className="assortmentDialog"
            >
                <div className="listHeader">
                    <div className="userColumn">{formatMessage("Who has access")}</div>
                    <div className="roleColumn">{formatMessage("Role")}</div>
                </div>
                <InfiniteLoader
                    isRowLoaded={this.props.isRowLoaded}
                    loadMoreRows={this.props.loadMoreRows}
                    rowCount={10000}
                    ref={this.bindInfiniteLoader}
                >
                    {({ onRowsRendered, registerChild }) => (
                        <AutoSizer disableHeight={true}>
                            {({ width }) => {
                                return (
                                    <List
                                        ref={registerChild}
                                        className="list"
                                        height={this.getListHeight()}
                                        onRowsRendered={onRowsRendered}
                                        rowCount={rowCount}
                                        rowHeight={ROW_HEIGHT}
                                        rowRenderer={this.props.rowRenderer}
                                        width={width}
                                    />
                                );
                            }}
                        </AutoSizer>
                    )}
                </InfiniteLoader>
                {permittedUsers.size === 0 && brandUsersOnly && (
                    <div className="noResults">{formatMessage("No Brand users have been invited yet.")}</div>
                )}
            </div>
        );
    }
}
